import Vue from "vue";
import Vuex, { createLogger } from "vuex";

import app from "@/stores/app";
import user from "@/stores/user";
import offer from "@/stores/offer";
import furtherOffer from "@/stores/furtherOffer";
import application from "@/stores/application";
import customer from "@/stores/customer";
import dlGroupConfig from "@/stores/dlgroup.config";
import info from "@/stores/info";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createLogger()],
  modules: {
    app,
    user,
    offer,
    furtherOffer,
    application,
    customer,
    dlGroupConfig,
    info
  }
});
